import { InputAdornment, TextField } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useMemo } from 'react';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';

import { DATA_TEST_ID } from '../../../../../../constants';
import { type NewsletterDialogForm } from '../../types';
import { useNewsletterDialogContext } from '../NewsletterDialogContext';
import { EMAIL_INPUT, adornmentIcons } from './constants';

export const EmailInput = () => {
  const { getTestId } = useTestId();
  const { register } = useFormContext<NewsletterDialogForm>();
  const { errors } = useFormState<NewsletterDialogForm>({ name: 'email' });
  const { content } = useNewsletterDialogContext();
  const email = useWatch<NewsletterDialogForm>({ name: 'email' });

  const endAdornment = useMemo(() => {
    if (!email) {
      return null;
    }
    const iconType = errors.email ? 'error' : 'success';

    return <InputAdornment position="end">{adornmentIcons[iconType]}</InputAdornment>;
  }, [email, errors.email]);

  const inputProps = useMemo(
    () => ({
      endAdornment,
      [DATA_TEST_ID]: getTestId(EMAIL_INPUT),
    }),
    [endAdornment, getTestId],
  );

  return (
    <TextField
      {...register('email', {
        setValueAs: (value: string) => value.trim(),
      })}
      autoFocus
      fullWidth
      required
      value={email}
      id="e-mail"
      error={!!errors.email}
      helperText={errors.email?.message}
      label={content.emailLabel}
      type="email"
      InputProps={inputProps}
    />
  );
};
